import { Button, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react'
import { getLocalStrg, getTruckName, formatINRCurrency } from '../utils/format';
import StyledTableContainer from './StyledTableContainer';
import { useNavigate } from 'react-router-dom';
import route from '../Routes';


function TpReqPymtReptTable({ tpReqData, columns }) {
    const navigate = useNavigate();
    async function handleReqIdClick(reqRow) {
        navigate(route.boTrkOpReqInfo + reqRow.truckOpReqId);
    }

    const arr = ['aHalting', 'aUlCooliDrv', 'aLdCooliDrv', 'aIncidental', 'aOthers', 'dTds', 'dCommission', 'dPenalty', 'dClaim', 'dLdCooli', 'dUlCooli', 'dFrtLess', 'dOthers', 'basePrc']

    return (
        <StyledTableContainer height={"83%"}>
            <TableHead>
                <TableRow>
                    {columns.map((column) => (
                        <TableCell
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            sx={{ color: "#8392AB", fontWeight: "bold", py: 1 }}
                            key={column.id}
                        >
                            {column.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {(tpReqData || []).map((dataRow, index) => {
                    return (
                        <TableRow hover tabIndex={-1} key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                            {columns.map((column) => {
                                const value = dataRow[column.id];
                                return (
                                    (column.id === "finalPricing" || column.id === "pendingAmount") ?
                                        <TableCell key={column.id} align={column.align} sx={{ textAlign: "left" }}>
                                            {"₹" + getLocalStrg(value)}
                                        </TableCell> : (arr.includes(column.id)) ?
                                            <TableCell key={column.id} align={column.align} sx={{ textAlign: "left" }}>
                                                {formatINRCurrency(value)}
                                            </TableCell> : (column.id === "trkOp") ?
                                                <TableCell key={column.id} align={column.align} sx={{ textAlign: "left" }}>
                                                    <Button variant="text" sx={{ color: "#000000", textAlign: "left" }} onClick={() => { navigate(route.boTrkOpInfo + dataRow.truckopId) }}>
                                                        {value}
                                                    </Button>
                                                </TableCell> : (column.id === 'truckOpReqId') ?
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Button variant="text" sx={{ color: "#000000", textAlign: "left" }} onClick={() => { handleReqIdClick(dataRow); }}>
                                                            {value}
                                                        </Button>
                                                    </TableCell> : (column.id === 'type') ?
                                                        <TableCell key={column.id} align={column.align} sx={{ textAlign: "left" }}>
                                                            {getTruckName(JSON.parse(dataRow?.type || "{}"))}
                                                        </TableCell> :
                                                        <TableCell key={column.id} align={column.align} sx={{ textAlign: "left" }} >
                                                            {value}
                                                        </TableCell>);
                            })}
                        </TableRow>
                    );
                })}
            </TableBody>
        </StyledTableContainer>
    )
}

export default TpReqPymtReptTable